import { useState } from "react";
import { Menu, X } from "lucide-react";

const NAV = [
  { label: "Services", href: "#services", id: "services" },
  { label: "Philosophy", href: "#philosophy", id: "philosophy" },
  { label: "Pricing", href: "#pricing", id: "pricing" },
  { label: "Work", href: "#work", id: "work" },
  { label: "Contact", href: "#contact", id: "contact" },
];

export default function Header({ scrolled }) {
  const [open, setOpen] = useState(false);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled
          ? "backdrop-blur-xl bg-[#FBF9F6]/85 border-b border-[#E5E0D8]"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto w-full px-6 md:px-12 h-20 flex items-center justify-between">
        <a
          href="#top"
          data-testid="header-logo"
          className="flex items-center gap-3"
          aria-label="Whitney Jean & Co. home"
        >
          <img
            src="/wj-logo.png"
            alt="Whitney Jean & Co."
            className="h-12 md:h-14 w-auto"
          />
          <span className="sr-only">Whitney Jean &amp; Co.</span>
        </a>

        <nav className="hidden md:flex items-center gap-10">
          {NAV.map((n) => (
            <a
              key={n.id}
              href={n.href}
              data-testid={`header-nav-link-${n.id}`}
              className="text-sm text-[#1C1B1A]/80 hover:text-[#1C1B1A] transition-colors relative group"
            >
              {n.label}
              <span className="absolute -bottom-1 left-0 h-px w-0 group-hover:w-full bg-[#1C1B1A] transition-all duration-300"></span>
            </a>
          ))}
        </nav>

        <a
          href="#contact"
          data-testid="header-cta-button"
          className="hidden md:inline-flex items-center gap-2 px-6 py-3 bg-[#1C1B1A] text-[#FBF9F6] text-sm hover:bg-[#33312E] transition-colors"
        >
          Book Free Consultation
          <span aria-hidden>→</span>
        </a>

        <button
          data-testid="header-mobile-toggle"
          onClick={() => setOpen(!open)}
          className="md:hidden p-2"
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div
          data-testid="header-mobile-menu"
          className="md:hidden border-t border-[#E5E0D8] bg-[#FBF9F6]"
        >
          <div className="px-6 py-6 flex flex-col gap-4">
            {NAV.map((n) => (
              <a
                key={n.id}
                href={n.href}
                onClick={() => setOpen(false)}
                data-testid={`header-mobile-nav-link-${n.id}`}
                className="text-lg text-[#1C1B1A]"
              >
                {n.label}
              </a>
            ))}
            <a
              href="#contact"
              onClick={() => setOpen(false)}
              data-testid="header-mobile-cta"
              className="mt-2 inline-flex items-center justify-center px-5 py-3 bg-[#1C1B1A] text-[#FBF9F6] text-sm"
            >
              Book Free Consultation
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
